/* eslint-disable import/prefer-default-export */

const excludedStatus = ['Pending Renewal', 'Inactive', 'Cancelled', 'Suspended', 'Expired'];

export const convertGBLStatus = (licence: string, status: string) => {
    switch (status) {
        case 'Pending Equipment Check':
        case 'Pending Negative List Decision':
        case 'Pending Negative List Approval':
        case 'Pending Approval':
        case 'Pending MHA Excel':
        case 'Pending Rejection Approval':
        case 'Pending MHA Clearance':
        case 'Pending Clearance Decision':
        case 'Pending Application Check':
        case 'Pending AC Approval':
        case 'Pending EC Approval':
        case 'Pending Frequency Allocation':
        case 'Pending IRN Processing':
        case 'IRN Processing':
        case 'Pending Agency Processing':
        case 'Frequency Allocation Processing':
        case 'Agency Processing':
        case 'Communication with Applicant':
        case 'External Agency Processing':
        case 'Pending New Approval':
        case 'Pending New LS2 Approval':
        case 'Pending New Issuance':
            return 'Processing';
        case 'Approved':
        case 'Pending Booklet Issuance':
        case 'PENDING BOOKLET ISSUANCE':
            return 'Licensed';
        case 'Withdrawn by Agency':
            return 'Rejected';
        case 'Active':
            return 'Active';
        case 'Pending Activation':
            return 'Pending Activation';
        case 'Pending Effective':
            return 'Pending Effective';
        case 'Pending Reinstatement Payment':
        case 'Cancelled–Pending EIP Inspection':
            return 'Cancelled';
        case 'Expired-Pending EIP Inspection':
            return 'Expired';
        default:
            if (licence === 'Services-Based Operations (Individual) Licence' && !excludedStatus.includes(status)) {
                return 'Processing';
            }
            return status;
    }
};
